<template>
  <div>
    <footer class="footer d-none d-xl-block d-lg-bock d-md-block">
      <div class="container text-left">
        <b-row col="2">
          <b-col md="2">
            <div class="mt-2"><router-link to="/impressum">Impresszum</router-link> <br /></div>
          </b-col>
          <b-col md="3" class="mt-2">
            <a download target="_blank" href="https://vali.hu/static/felhasznalasi_feltetelek.pdf">
              Felhasználási feltételek
            </a>
          </b-col>
          <b-col md="2" class="mt-2">
            <a download target="_blank" href="https://vali.hu/static/adatkezelesi_tajekoztato.pdf">
              Adatvédelem
            </a>
          </b-col>
          <b-col md="3" class="mt-2">
            <a download target="_blank" href="https://vali.hu/static/cookie_tajekoztato.pdf">
              Süti tájékoztató
            </a>
          </b-col>

          <b-col md="2" class="mt-2">
            <router-link to="/contact">Kapcsolat</router-link>
          </b-col>
        </b-row>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: var(--footer-bgcolor);
  color: var(--footer-fontcolor);
  z-index: 1001;
  flex-shrink: 0;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 20px;
  /*position: relative;*/
  min-height: 150px;
}

img {
  max-width: 200px;
  position: fixed;
  right: 0;
  bottom: 0;
}

a {
  font-size: 18px;
  text-decoration: none;
  color: white;
}
</style>
